export default {
    CREATED: 'CREATED',
    UPDATED: 'UPDATED',
    REMOVED: 'REMOVED',
    DELETED: 'DELETED',
    ADDED: 'ADDED',
    NEW: 'NEW',
};
